import actions from '../constants/MusicActions';

/**
 * action notifying of the intent to fetch artist for a given track
 *
 * @param  {string} token - musicId or seoToken of the artist to look up
 * @param {boolean} redirectOnNotFound - if true, redirects user to Not Found page if artist isn't found
 * @returns {object} - return an Action
 */
export function getArtist(token, redirectOnNotFound = true) {
  return {
    type: actions.GET_ARTIST,
    data: {
      token,
      redirectOnNotFound,
    },
  };
}

/**
 * action notifying of the intent to fetch track
 *
 * @param {string} token - musicId or seoToken of the track to look up
 * @param {boolean} redirectOnNotFound - if true, redirects user to Not Found page if track isn't found
 * @returns {object} - return an Action
 */
export function getTrack(token, redirectOnNotFound = true) {
  return {
    type: actions.GET_TRACK,
    data: {
      token,
      redirectOnNotFound,
    },
  };
}

/**
 * action notifying of the intent to fetch album
 *
 * @param {string} token - musicId or seoToken of the album to look up
 * @param {boolean} getAlbumArtist - if album is found, fetch album artist as well
 * @param {boolean} redirectOnNotFound - redirect user to Not Found page if album isn't found
 * @returns {object} - return an Action
 */
export function getAlbum(token, getAlbumArtist = true, redirectOnNotFound = true) {
  return {
    type: actions.GET_ALBUM,
    data: {
      token,
      getAlbumArtist,
      redirectOnNotFound,
    },
  };
}

/**
 * action notifying of the intent to get lyrics for a given track
 *
 * @param  {string} pandoraId - the pandoraId for the track
 * @param  {boolean} isExplicit - the user's setting for explicit lyrics
 * @returns {object} - return an Action
 */
export function getLyrics({ pandoraId, isExplicit }) {
  return {
    type: actions.GET_LYRICS,
    data: {
      pandoraId,
      isExplicit,
    },
  };
}
